export default __webpack_public_path__ + "static/media/119.bcd35991.webp";